import { selfAxios } from "../../../../axios/selfAxios.js";
async function postPreStartMTDSServiceDesk() {
  const { data } = await selfAxios.post(`/designordercenter/serviceDesk/preStartMTDSServiceDesk`);
  return data == null ? void 0 : data.data;
}
export { postPreStartMTDSServiceDesk };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/serviceDesk/preStartMTDSServiceDesk/post.js